import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as marketingState from '../auth.reducer';
import * as marketingReducer from '../reducers/get-marketing.reducer';

export const getMarketing = createSelector(marketingState.getMarketingState, marketingReducer.getMarketingResponse);

export const getMarketingLoaded = createSelector(marketingState.getMarketingState, marketingReducer.getMarketingLoaded);
